var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('el-tabs',{staticClass:"elTabs",attrs:{"type":"card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"个人信息","name":"first"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }